import { Dispatch, SetStateAction } from 'react';
import { ModalState } from '../../models';
import { ModalContentWrapper, ModalTitleWrapper } from '../common/Modal';
import { H3 } from '../styled/typography';
import { initialModalState } from '../../models/modal';
import { RedButton } from '../styled/Button';
import EmailDoneSVG from '../../public/img/email-done.svg';

export function CommentsModalSuccess({
  modal,
  setModalState,
}: {
  modal: {
    title: string;
    description: string;
  };
  setModalState: Dispatch<SetStateAction<ModalState>>;
}) {
  return (
    <ModalContentWrapper>
      <div css={{ padding: '20px' }}>
        <ModalTitleWrapper
          css={{ height: 'auto', padding: 0 }}
          setModalState={setModalState}
          customClose={<span />}
        >
          <H3
            css={{ fontFamily: 'Montserrat', fontSize: 16, fontWeight: 600 }}
            dangerouslySetInnerHTML={{ __html: modal.title }}
          />
        </ModalTitleWrapper>
      </div>
      <div
        css={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          marginBottom: 20,
          marginTop: 20,
        }}
      >
        <EmailDoneSVG
          css={{
            width: 120,
            height: 120,
            fill: '#f84431',
            transform: 'rotate(-30deg)',
          }}
        />
      </div>
      <div
        css={{ padding: '0 20px 60px 20px', fontWeight: 600 }}
        dangerouslySetInnerHTML={{ __html: modal.description }}
      />
      <div
        css={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          marginBottom: 20,
        }}
      >
        <RedButton callback={() => setModalState(initialModalState)}>
          Хорошо
        </RedButton>
      </div>
    </ModalContentWrapper>
  );
}
